import type { YourRentalPageDto } from '@zg-rentals/ts-your-rental-api-client';

export const EMPTY_YOUR_RENTAL_PAGE: YourRentalPageDto = {
  defaultPropertyIndex: 0,
  yourRentalProperties: [],
};
